import type {
  InputHTMLAttributes,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from "react";

type BaseProps = {
  label: string;
  hint?: string;
  fullWidth?: boolean;
  wrapperClassName?: string;
};

export type CertificationInputFieldProps = BaseProps & InputHTMLAttributes<HTMLInputElement>;
export type CertificationTextareaFieldProps = BaseProps & TextareaHTMLAttributes<HTMLTextAreaElement>;
export type CertificationSelectFieldProps = BaseProps & SelectHTMLAttributes<HTMLSelectElement>;

export function CertificationInputField({
  label,
  hint,
  fullWidth = false,
  wrapperClassName = "",
  ...props
}: CertificationInputFieldProps) {
  return (
    <label className={`iso27001-field ${fullWidth ? "iso27001-field-full" : ""} ${wrapperClassName}`.trim()}>
      <span>{label}</span>
      <input {...props} />
      {hint ? <small>{hint}</small> : null}
    </label>
  );
}

export function CertificationTextareaField({
  label,
  hint,
  fullWidth = false,
  wrapperClassName = "",
  ...props
}: CertificationTextareaFieldProps) {
  return (
    <label className={`iso27001-field ${fullWidth ? "iso27001-field-full" : ""} ${wrapperClassName}`.trim()}>
      <span>{label}</span>
      <textarea {...props} />
      {hint ? <small>{hint}</small> : null}
    </label>
  );
}

export function CertificationSelectField({
  label,
  hint,
  fullWidth = false,
  wrapperClassName = "",
  children,
  ...props
}: CertificationSelectFieldProps) {
  return (
    <label className={`iso27001-field ${fullWidth ? "iso27001-field-full" : ""} ${wrapperClassName}`.trim()}>
      <span>{label}</span>
      <select {...props}>{children}</select>
      {hint ? <small>{hint}</small> : null}
    </label>
  );
}
